import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_FHIRResourceSubtype } from '@app/fhir-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onFHIRResourceSubtypesUpdated = new ThunderDispatcherV3('__onFHIRResourceSubtypesUpdated');
export class ModuleFE_FHIRResourceSubtype_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_FHIRResourceSubtype, dispatch_onFHIRResourceSubtypesUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_FHIRResourceSubtype = new ModuleFE_FHIRResourceSubtype_Class();
//# sourceMappingURL=ModuleFE_FHIRResourceSubtype.js.map